import useExperiment from 'hooks/Experiments/useExperiment'
import { Experiments } from 'constants/experiments'
import { isNearCentreFlashBoostRankingEligible } from 'constants/nearCentreFlashBoostRankingDestinations'

interface UseNearCentreFlashBoostRankingResult {
  experimentVariant: string | undefined
}

function useNearCentreFlashBoostRanking(
  filters: App.OfferListFilters,
  options?: { disabled?: boolean },
): UseNearCentreFlashBoostRankingResult {
  const canActivate = !options?.disabled && isNearCentreFlashBoostRankingEligible(filters)

  const { isAnyVariant, variation } = useExperiment(
    Experiments.searchNearCentreFlashBoostRanking,
    { canActivate },
  )
  const experimentVariant = canActivate && isAnyVariant ? variation : undefined

  return { experimentVariant }
}

export default useNearCentreFlashBoostRanking
